import React from "react";
import { CheckBox as NovusCheckbox } from "@arcadis-intelligence/novus-design-system";
import { checkBoxStyles } from "../variants";
interface Props {
    checked?: boolean;
    id?: string;
    color?: string;
    backgroundColor?: string;
    boxShadowColor?: string;
    borderColor?: string;
    hoverColor?: string;
    focusColor?: string;
    title?: string;
    text?: string;
    size?: "sm" | "md";
    disabled?: boolean;
    indeterminate?: boolean;
    className?: string;
    customStyles?: object;
    onChange?: (e: boolean) => void;
    onKeyDown?: () => void;
    tabIndex?: number;
    dataTestId?: string;
    subtext?: string;
}

export const CheckBox: React.FC<Props> = ({
    borderColor,
    boxShadowColor,
    checked,
    className,
    color,
    customStyles,
    dataTestId,
    disabled,
    focusColor,
    hoverColor,
    id,
    indeterminate,
    onChange,
    onKeyDown,
    size,
    subtext,
    tabIndex,
    text,
    title
}) => {
    return (
        <>
            <NovusCheckbox
                backgroundColor={color ? color : checkBoxStyles.backgroundColor}
                borderColor={
                    borderColor || color
                        ? borderColor
                            ? borderColor
                            : color
                        : checkBoxStyles.borderColor
                }
                boxShadowColor={
                    boxShadowColor || color
                        ? boxShadowColor
                            ? boxShadowColor
                            : `${color}40`
                        : checkBoxStyles.boxShadowColor
                }
                className={className}
                customStyles={customStyles}
                dataTestId={dataTestId}
                disabled={disabled}
                focusColor={
                    focusColor || color
                        ? focusColor
                            ? focusColor
                            : color
                        : checkBoxStyles.focusColor
                }
                hoverBorderColor={
                    hoverColor || color
                        ? hoverColor
                            ? hoverColor
                            : color
                        : checkBoxStyles.hoverBorderColor
                }
                id={id}
                indeterminate={indeterminate}
                onClick={() => {
                    onChange && onChange(!checked);
                }}
                onKeyDown={onKeyDown}
                selected={checked}
                size={size}
                subtext={subtext}
                tabIndex={tabIndex}
                text={text}
                title={title}
            />
        </>
    );
};
